import React from 'react';
import { Card } from './ui/card';
import { Handshake, MapPin, Receipt, Heart } from 'lucide-react';
import { whyUs } from '../data/mock';

const iconMap = {
  Handshake: Handshake,
  MapPin: MapPin,
  Receipt: Receipt,
  Lotus: Heart
};

const WhyUs = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Why We Offer the Best Prices in Rishikesh
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            We're not just another wedding planner. We're Rishikesh locals who believe 
            in honest pricing, direct partnerships, and creating mindful celebrations. 
            Premium venues, exceptional quality, unbeatable value.
          </p>
        </div>

        {/* Value Highlight */}
        <div className="bg-gradient-to-br from-amber-50 to-emerald-50 rounded-3xl p-8 md:p-12 mb-16 border border-amber-200">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                Premium Experience, Best Value
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start space-x-3">
                  <span className="text-amber-600 text-xl">✓</span>
                  <span className="text-gray-700">Stunning riverside venues with Ganges views</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="text-amber-600 text-xl">✓</span>
                  <span className="text-gray-700">Luxury accommodations and premium resorts</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="text-amber-600 text-xl">✓</span>
                  <span className="text-gray-700">Experienced coordinators and photographers</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="text-amber-600 text-xl">✓</span>
                  <span className="text-gray-700">Premium floral decor and catering</span>
                </li>
              </ul>
            </div>
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="text-center">
                <div className="text-5xl font-bold text-amber-700 mb-2">#1</div>
                <div className="text-xl font-semibold text-gray-900 mb-3">Best Prices in Rishikesh</div>
                <div className="text-gray-600">
                  Direct venue partnerships.<br />
                  No hidden fees.<br />
                  Transparent, honest pricing.
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Why Us Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {whyUs.map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <Card
                key={item.id}
                className="p-6 hover:shadow-xl transition-shadow duration-300 border border-gray-200"
              >
                <div className="bg-amber-100 w-14 h-14 rounded-full flex items-center justify-center mb-4">
                  <IconComponent size={28} className="text-amber-700" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {item.description}
                </p>
              </Card>
            );
          })}
        </div>

        {/* Trust Statement */}
        <div className="mt-16 text-center max-w-4xl mx-auto bg-gray-50 rounded-2xl p-8">
          <blockquote className="text-2xl font-medium text-gray-800 mb-4 italic">
            "We built Jeevan Utsav Retreat on a simple belief: every couple deserves the best possible 
            value for their dream Rishikesh wedding. Our local roots and direct vendor relationships 
            allow us to offer the best prices in town."
          </blockquote>
          <div className="text-amber-700 font-semibold">
            — The Jeevan Utsav Retreat Team, Rishikesh
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
